// extracted by mini-css-extract-plugin
export var button = "Hero-module--button--f748e";
export var customerLogos = "Hero-module--customerLogos--4eac9";
export var heroSection = "Hero-module--heroSection--4b771";
export var imageWrapper = "Hero-module--imageWrapper--e4659";
export var wrapper = "Hero-module--wrapper--0df2c";